import request from '~/utils/http';

// 进口订单
export function getOrder(sendData) {
  return request({
    url: 'api/AgentOrder/GetList',
    method: 'post',
    data: sendData
  })
}

// 进口订单详细
export function getOrderDetail(sendData) {
  return request({
    url: 'api/AgentOrder/Get',
    method: 'post',
    data: sendData
  })
}

// 进口订单
export function AddOrder(sendData) {
  return request({
    url: 'api/AgentOrder/Add',
    method: 'post',
    data: sendData
  })
}

// 进口订单
export function EditOrder(sendData) {
  return request({
    url: 'api/AgentOrder/Edit',
    method: 'post',
    data: sendData
  })
}

// 本港单
export function getHKOrder(sendData) {
  return request({
    url: 'api/HKAgentOrder/GetList',
    method: 'post',
    data: sendData
  })
}
export function getHKOrderDetail(sendData) {
  return request({
    url: 'api/HKAgentOrder/Get',
    method: 'post',
    data: sendData
  })
}

// 出库单
export function getHKStock(sendData) {
  return request({
    url: 'api/BGStockOut/GetList',
    method: 'post',
    data: sendData
  })
}
// 出库单详情
export function getHKStockDetail(sendData) {
  return request({
    url: 'api/BGStockOut/Get',
    method: 'post',
    data: sendData
  })
}

export function getReservedNo(sendData){
  return request({
    url: 'api/ReservationNumber/GetAvailableList',
    method: 'post',
    data: sendData
  })
}

export function getCurContract(sendData){
  return request({
    url: 'api/ClientContract/GetCurrentContract',
    method: 'post',
    data: sendData
  })
}
